import { logoPartnerList } from 'constants/logoPartner';
import styles from './footer.styles';

function Footer() {
    return (
        <div className={styles.wrap}>
            <div className={styles.contentPolicy}>
                <p>Quy Định Luật Lệ</p>
                <div className="line" />
                <p>Trách nhiệm người chơi</p>
                <div className="line" />
                <p>Chính sách bảo mật</p>
                <div className="line" />
                <p>Tuyên bố bản quyền</p>
            </div>

            <div className={styles.partnerList}>
                {logoPartnerList.map((item, index) => (
                    <div className={styles.partnerItem} key={index}>
                        <img src={item} alt="" />
                    </div>
                ))}
            </div>

            <div className={styles.partnerList}>
                <div className="itemFooter">
                    <img alt="" src={require('assets/images/logo-footer/logo-pagcor.png')} />
                    <p>
                        Trang mạng cá cược{' '}
                        <a href="/" className="loto">
                            VuiBet
                        </a>{' '}
                        hoạt động hợp pháp tại Philippines (Giấy phép PAGCOR số OGL16-0023) được giám sát bởi tổ chức Gaming Associates.
                    </p>
                </div>
                <div className="itemFooter">
                    <img alt="" src={require('assets/images/logo-footer/18+.png')} />
                    <p>Chúng tôi tích cực đẩy mạnh cá cược có trách nhiệm và cương quyết từ chối trẻ vị thành niên sử dụng phần mềm của chúng tôi để cá cược trên mạng.</p>
                </div>
            </div>
        </div>
    );
}

export default Footer;
